import {
    Box,
    Heading,
    SimpleGrid,
    Text,
    useColorModeValue,
    Flex,
    Input,
    IconButton,
    useDisclosure,
    InputGroup,
    Modal,
    ModalOverlay,
    ModalHeader,
    ModalBody,
    ModalContent,
    FormControl,
    FormLabel,
    ModalFooter,
    InputLeftAddon,
    MenuList,
    Menu,
    MenuButton,
    MenuItem,
    Link,
    Checkbox,
    Tooltip,
    Icon,
    Tag
} from "@chakra-ui/react";
import * as React from "react";
import { Button } from "@chakra-ui/button";
import { loadStripe, StripeCardElement } from "@stripe/stripe-js";
import { postData } from "../../utils/helpers";
import { FiUnlock } from "react-icons/fi";
import { firebaseClient } from "../../firebaseClient";
import { useSession } from "next-auth/client";
import toast from "react-hot-toast";
import { getAccount, updateUser } from "utils/sessionHelper";
import { ImCross } from "react-icons/im";
import { AiOutlineLock, AiOutlineShareAlt } from "react-icons/ai";
import { ConfirmPopup } from "components/popups/confirmPopup";
import { Member } from "components/subscriptionManagement/member";
import { ChevronDownIcon } from "@chakra-ui/icons";
import { useFirebaseUser } from "utils/useFirebaseUser";
import * as EmailValidator from 'email-validator';
import { CustomSection } from "components/custom-section";


export const OrgManagement = (props) => {

    const [session] = useSession();
    const [isLoading, setIsLoading] = React.useState(false);
    const [twUserName, setTwUserName] = React.useState("");
    const [email, setEmail] = React.useState("");
    const [refresh, refresher] = React.useState({});
    const [members, setMembersInternal] = React.useState<any>([]);
    const [selectedMember, setSelectedMember] = React.useState<any>({});
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isOpenInfo, onOpen: onOpenInfo, onClose: onCloseInfo } = useDisclosure();
    const { isOpen: isOpenRemove, onOpen: onOpenRemove, onClose: onCloseRemove } = useDisclosure();
    const { isOpen: isOpenQuit, onOpen: onOpenQuit, onClose: onCloseQuit } = useDisclosure();
    const [isShare, setIsShare] = React.useState(false);
    const isAuthenticated = useFirebaseUser();
    const warnTeamBoxBgColor = useColorModeValue("gray.100", "gray.700");
    const teamMemberBgColor = useColorModeValue("gray.50", "gray.700");

    React.useEffect(() => {
        if (session?.user?.data?.members) {
            setMembers(session?.user?.data?.members);
        }
        if (isAuthenticated) {
            setIsShare(!!getAccount(session)?.orgAcceptShare);

        }
    }, [isAuthenticated])

    const setMembers = function (newMembers, newIsShare = undefined as any) {

        let selfMember = newMembers?.find((m) => m.id === session?.user?.uid);
        if (selfMember)
            selfMember.orgAcceptShare = newIsShare ?? session?.user?.data?.orgAcceptShare;

        setMembersInternal([...newMembers]);
    }

    const quitOrganization = async () => {
        console.log("quitOrganization");
        let result = await postData({
            url: "payment-quitOrganization", token: "",
            data: {},
            session,
        });
        setIsLoading(false);
        if (result.success) {
            toast.success("Organization exited successfully");
            if (session?.user?.data?.subscription?.isInOrg)
                session.user.data.subscription.isInOrg = false;
            refresher({});
        }
        else {
            toast.error("Error: " + result.message);
        }
    }

    const removeMember = async () => {
        console.log("delete account: ", selectedMember);
        let result = await postData({
            url: "payment-removeTeamMember", token: "",
            data: {
                twUserNameToRemove: selectedMember.twUserName, // TO REFLECT UPDATE
                idToRemove: selectedMember.id,
                twUserNameOwner: session?.user?.data?.twUserName, // TO REFLECT UPDATE
                idOrg: session?.user?.data?.subscription?.org,
            },
            session,
        });
        setIsLoading(false);
        if (result.success) {
            setMembers(result.members);
            toast.success("Team member removed");
        }
        else {
            toast.error("Error: " + result.message);
        }
    }

    const addMember = async () => {

        setIsLoading(true);
        let result = await postData({
            url: "payment-addTeamMember", token: "",
            data: {
                twUserName,
                email: email.toLowerCase(),
                name: getAccount(session).name,
                twUserNameOwner: session?.user?.data?.twUserName,
                idOrg: session?.user?.data?.subscription?.org || session?.user?.data?.id,
            },
            session,
        });
        setIsLoading(false);
        if (result.success) {
            toast.success("Team member added");
            setMembers(result.members);
            // onOpenInfo();
        }
        else {
            toast.error("Error: " + result.message);
        }
    }

    let isOwner = session?.user?.data?.subscription?.org == session?.user?.uid;

    // console.log("id user: " + getAccount(session)?.id);
    // console.log("id account: " + getAccount(session)?.idAccount);
    // console.log("id parent: " + getAccount(session)?.idParent);

    return (
        <CustomSection
            title="Team & Permissions"
            description="Manage your team"
            css={{ maxW: "600px" }}
        >
            <Flex flexDir="column" maxW="800px">
                <Checkbox
                    mt={10}
                    disabled={getAccount(session)?.idAccount !== getAccount(session)?.id}
                    fontWeight="medium"
                    isChecked={isShare}
                    onChange={async (e) => {
                        setMembers([...members], !isShare);
                        setIsShare(!isShare);
                        await updateUser(session, { orgAcceptShare: !isShare });
                    }}
                >
                    Share my primary account with my organization
                </Checkbox>
                {getAccount(session)?.idAccount !== getAccount(session)?.id ? (
                    <Box mt="5">
                        <Tag mt={2} colorScheme="orange" size="md">⚠️ Secondary X accounts cannot be shared with organization</Tag>
                    </Box>
                ) : null}
                {
                    session?.user?.data?.subscription?.isInOrg && session?.user?.data?.subscription?.orgRole !== "Admin" ? (
                        <Flex flexDir="column" mt={10}>
                            <Text mt={0}>You are in an organization managed by <b>@{session?.user?.data?.subscription?.orgTwUserNameOwner}</b></Text>
                            <Button
                                // colorScheme="red"
                                variant={"secondaryDestructive"}
                                w="200px"
                                mt={5}
                                onClick={onOpenQuit}
                                isLoading={isLoading}
                            >
                                Quit Organization
                            </Button>
                        </Flex>
                    ) : (
                        <Flex flexDir="column">
                            <Text mt={10} textStyle="body.medium.standard">Get your team members their own Tweet Hunter account under your subscription</Text>
                            <Text mt={0} textStyle="body.medium.light"><i>Billing will be adjusted accordingly</i></Text>
                            <Text mt={4} textStyle="body.medium.light">{"2+ team members -> get 25% discount"}</Text>
                            <Text mt={0} textStyle="body.medium.light">{"11+ team members -> get 30% discount"}</Text>
                            <Text mt={0} textStyle="body.medium.light">{"51+ team members -> get 35% discount"}</Text>
                            <Flex mt={5} flexDirection="column" w={{ base: "100%", md: "400px" }}>
                                <Box alignItems="start" display={{ md: "flex" }}>
                                    <Text textStyle="body.medium.light" minW="120px" mt="2">X Handle: </Text>
                                    <Box mt={{ base: "1", md: "0" }} flex="1">
                                        <Input value={twUserName} onChange={(e) => { setTwUserName(e.target.value) }} placeholder="@twitter_handle" />
                                        <Text fontSize="xs" ml="2" mt="1" textStyle="body.medium.light">Field is case-sensitive</Text>
                                    </Box>
                                </Box>
                                <Box alignItems="center" mt="3" display={{ md: "flex" }}>
                                    <Text minW="120px" textStyle="body.medium.light">Email: </Text>
                                    <Input mt={{ base: "1", md: "2" }} value={email} onChange={(e) => { setEmail(e.target.value) }} placeholder="colleague@company.com" />
                                </Box>
                                <Button
                                    mt={2}
                                    isLoading={isLoading}
                                    isDisabled={!twUserName?.length || !session?.user?.data?.subscription?.isSubscribed || !session?.user?.data?.subscription?.subscription}
                                    onClick={async () => {

                                        // validate Twitter handle
                                        if (!twUserName || !twUserName.match(/^[@a-zA-Z0-9_]{1,16}$/g)) {
                                            toast.error("Invalid Twitter handle");
                                            return;
                                        }

                                        if (!email || !EmailValidator.validate(email.toLowerCase())) {
                                            toast.error("Invalid Email");
                                            return;
                                        }

                                        onOpen();
                                    }}
                                    // bg="blue.100"
                                    // _hover={{ bg: "blue.200" }}
                                    // color="gray.800"
                                    variant="secondary"
                                >
                                    Send invitation
                                </Button>
                            </Flex>
                            {
                                isAuthenticated && !session?.user?.data?.subscription?.subscription && (
                                    <Flex mt={5} flexDir="column" maxW="600px" bg={warnTeamBoxBgColor} p={5} rounded="lg">
                                        <Text textStyle="body.medium.standard">⚠️ You can't add team members since you don't have an active subscription</Text>
                                        {
                                            session?.user?.data?.subscription?.isVip && (
                                                <Text textStyle="body.medium.light" mt={2}><b>As a VIP</b>, get a normal subscription and the first team member will be free</Text>
                                            )
                                        }
                                        <Box>
                                            <Button mt={5} as="a" href="/pricing" variant={"secondary"}>
                                                Get a subscription
                                            </Button>
                                        </Box>
                                    </Flex>
                                )
                            }
                            {
                                members?.length > 0 ? (
                                    <Flex mt={5} flexDir="column" maxW="600px">
                                        {
                                            members.map((member, index) => (
                                                <Member key={"membercomp" + index} index={index} member={member} setMembers={setMembers} setSelectedMember={setSelectedMember} onOpenRemove={onOpenRemove} isOwner={isOwner} />
                                            ))
                                        }
                                    </Flex>
                                ) : (
                                    <Box>
                                    </Box>
                                )
                            }
                            {
                                members?.some(x => x.status == "pending") && (
                                    <Text textStyle="body.medium.light" mt={5}>⚠️ If new team member didn't get their email invitation, tell them to go here: <Link href="https://app.tweethunter.io/invite" isExternal >app.tweethunter.io/invite</Link></Text>
                                )
                            }
                        </Flex>
                    )
                }
                <ConfirmPopup
                    isOpen={isOpen}
                    onClose={onClose}
                    title="Add new team member"
                    body={"Are you sure you want to add this member to your team? Your billing will be adjusted accordingly."}
                    callback={addMember}
                />
                <ConfirmPopup
                    isOpen={isOpenRemove}
                    onClose={onCloseRemove}
                    title="Remove a team member"
                    body={"Are you sure you want to remove this member from your team?"}
                    callback={removeMember}
                    allowClickBackground={true}
                />
                <ConfirmPopup
                    isOpen={isOpenQuit}
                    onClose={onCloseQuit}
                    title="Quit your organization"
                    body={"Are you sure you want to quit your organization? You will lose your team subscription."}
                    callback={quitOrganization}
                    allowClickBackground={true}
                />
                <Modal
                    isOpen={isOpenInfo}
                    onClose={onCloseInfo}
                    closeOnOverlayClick={false}
                    size="xl"
                >
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>
                            <Box display="flex" justifyContent="space-between">
                                <Text textStyle="h4.bold.standard">{`Congrats! You added @${twUserName} to your plan!`}</Text>
                            </Box>
                        </ModalHeader>
                        <ModalBody >
                            <Heading textStyle="h4.bold.standard" >What’s next?</Heading>
                            <Heading textStyle="h4.bold.standard" mt={5} mb={2}>1. Changes in your billing</Heading>
                            <Text textStyle="body.medium.light" whiteSpace="pre-line">{`All the accounts you add here will be billed for the same amount as your original account, on the same card, with the same billing details. They will all have the same plan (Discover, Grow or Enterprise).

When you add an account, a pro-rata amount is billed to your card for the first month. For example, if there were 15 days left until your next billing cycle when you added the account, only 15 days will be billed for the 1st month. The following months, you will be billed on the day you are usually billed on, and for the total amount.`}</Text>
                            <Text textStyle="h4.bold.standard" mt={5} mb={2}>2. Accessing the account</Text>
                            <Text textStyle="body.medium.light" whiteSpace="pre-line">{`If the user you added had already created a Tweet Hunter account (without subscribing), then it will be upgraded to a paying account automatically. The owner can sign in to Tweet Hunter with said account and access it straight away, like a normal paying user.

Same goes if no Tweet Hunter account had been previously created. The user can sign up to Tweet Hunter using the proper Twitter account, and will access the app immediately without having to subscribe.`}</Text>
                        </ModalBody>

                        <ModalFooter p={3}>
                            {/* <Button onClick={skipPopup} mr={3}>Skip</Button> */}
                            <Button
                                onClick={async () => {
                                    onCloseInfo();
                                }}
                                variant={"primary"}
                            >
                                Ok, got it
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>
            </Flex>
        </CustomSection>
    );
};

export default OrgManagement;
